import { useState, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

const populationsToFilter = [
  'blind_or_low_vision',
  'deaf_or_hard_of_hearing',
  'people_with_chronic_conditions',
  'people_with_learning_disabilities',
];

function useFilteredPopulations(populations) {
  const [filteredPopulations, setFilteredPopulations] = useState(populations);
  const { hint1426SharesShowNewPopulations } = useFlags();

  useEffect(() => {
    setFilteredPopulations(hint1426SharesShowNewPopulations
      ? populations
      : populations.filter((population) => !populationsToFilter.includes(population)));
  }, [hint1426SharesShowNewPopulations, populations]);

  return filteredPopulations;
}

export default useFilteredPopulations;
